import authApiService from './userApiService';

const handleError = (error) => ({
  success: false,
  error:
    error.response?.data?.error ||
    error.response?.data?.message ||
    error.message ||
    'Analytics chat request failed',
  data: error.response?.data || null,
  statusCode: error.response?.status,
});

const handleSuccess = (response) => ({
  success: true,
  data: response.data,
  statusCode: response.status,
});

export const DASHBOARD_CHAT_METRICS = [
  { value: 'competition_status', label: 'Competition status' },
  { value: 'total_tables', label: 'Cash table totals' },
  { value: 'tournament_totals', label: 'Tournament totals' },
  { value: 'unique_games', label: 'Unique games' },
  { value: 'day_wise_breakdown', label: 'Day-wise breakdown' },
  { value: 'game_type_breakdown', label: 'Game type breakdown' },
  { value: 'top_games_by_hour', label: 'Top games by hour' },
];

export const DASHBOARD_CHAT_VENUES = [
  { value: 'both', label: 'Both venues' },
  { value: 'epl', label: 'EPL' },
  { value: 'competitor', label: 'TCH' },
];

export const dashboardChatService = {
  async ask(message) {
    try {
      const response = await authApiService.post('/dashboard-chat/', { message });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async query({ startDate, endDate, venue = 'both', metric }) {
    try {
      const response = await authApiService.post('/dashboard-chat/query', {
        startDate,
        endDate,
        venue: venue === 'tch' ? 'competitor' : venue,
        metric,
      });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },
};
